/* eslint-disable consistent-return */
// eslint-disable-next-line import/prefer-default-export
import pallete from './nineColorPallete';

export 	const defaultColors = (filters) => {
	if (filters.climate === 'High levels of precipitation/High levels of waterlogging' && filters.conflict === 'Limited conflict') {
		return { color: '#656565', opacity: 1, fillColor: pallete[0], fillOpacity: 1, weight: 1 };
	} if (filters.climate === 'High levels of precipitation/High levels of waterlogging' && filters.conflict === 'Moderate conflict') {
		return { color: '#656565', opacity: 1, fillColor: pallete[1], fillOpacity: 1, weight: 1 };
	} if (filters.climate === 'High levels of precipitation/High levels of waterlogging' && filters.conflict === 'High conflict') {
		return { color: '#656565', opacity: 1, fillColor: pallete[2], fillOpacity: 1, weight: 1 };
	} if (filters.climate === 'Moderate levels of precipitation/Moderate levels of waterlogging' && filters.conflict === 'Limited conflict') {
		return { color: '#656565', opacity: 1, fillColor: pallete[3], fillOpacity: 1, weight: 1 };
	} if (filters.climate === 'Moderate levels of precipitation/Moderate levels of waterlogging' && filters.conflict === 'Moderate conflict') {
		return { color: '#656565', opacity: 1, fillColor: pallete[4], fillOpacity: 1, weight: 1 };
	} if (filters.climate === 'Moderate levels of precipitation/Moderate levels of waterlogging' && filters.conflict === 'High conflict') {
		return { color: '#656565', opacity: 1, fillColor: pallete[5], fillOpacity: 1, weight: 1 };
	} if (filters.climate === 'Low levels of precipitation/High levels of heat stress' && filters.conflict === 'Limited conflict') {
		return { color: '#656565', opacity: 1, fillColor: pallete[6], fillOpacity: 1, weight: 1 };
	} if (filters.climate === 'Low levels of precipitation/High levels of heat stress' && filters.conflict === 'Moderate conflict') {
		return { color: '#656565', opacity: 1, fillColor: pallete[7], fillOpacity: 1, weight: 1 };
	} if (filters.climate === 'Low levels of precipitation/High levels of heat stress' && filters.conflict === 'High conflict') {
		return { color: '#656565', opacity: 1, fillColor: pallete[8], fillOpacity: 1, weight: 1 };
	}

	return { fillOpacity: 0, opacity: 0 };
};

export 	const backgroundColors = (variable) => {
	if (variable === 'High levels of precipitation/High levels of waterlogging' || variable === 'Limited conflict') {
		return { backgroundColor: pallete[0] };
	}
	if (variable === 'Moderate levels of precipitation/Moderate levels of waterlogging' || variable === 'Moderate conflict') {
		return { backgroundColor: pallete[4] };
	}
	if (variable === 'Low levels of precipitation/High levels of heat stress' || variable === 'High conflict') {
		return { backgroundColor: pallete[8] };
	}
	return { backgroundColor: pallete[0] };
};

export const pal = pallete;
